import { useRoutes } from 'react-router-dom';
import routes from 'src/router';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import { SnackbarProvider } from 'src/utils/snackbar'
import { ThemeProvider } from 'src/contexts/ThemeContext';

function App() {
  const content = useRoutes(routes);
  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <SnackbarProvider>
          {content}
        </SnackbarProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}
export default App;
